module.exports = __webpack_public_path__ + "img/hohlsaum_silbergrau_ral9006.75040d33.jpg";